import type { ImageDefinitionCondition } from 'types/images'

export const isEnergyPitchLegacyVariant: ImageDefinitionCondition = (
  growthBook
) => {
  const variant = growthBook.evalFeature(
    'onboarding_energy_pitch_variant'
  )?.value
  return !variant || variant === 'legacy'
}

export const isEnergyPitchFunnelSpecificVariant: ImageDefinitionCondition = (
  growthBook
) => {
  const variant = growthBook.evalFeature(
    'onboarding_energy_pitch_variant'
  )?.value
  return variant === 'funnel_specific'
}

export const isSocialProofMillionsVariant =
  (variant: string): ImageDefinitionCondition =>
  (growthBook) => {
    const gbVariant = growthBook.evalFeature(
      'onboarding_social_proof_millions_variant'
    )?.value
    if (variant === 'default' && !gbVariant) {
      return true
    }
    return gbVariant === variant
  }
